import styles from './RichText.module.css';

function Run({ run }) {
  let node = run.text;
  if (run.underline) node = <u>{node}</u>;
  if (run.italic) node = <em>{node}</em>;
  if (run.bold) node = <strong>{node}</strong>;
  return node;
}

const Runs = ({ runs }) => runs.map((run, i) => <Run key={i} run={run} />);

/**
 * Renders a rich text document (see richText.js) as elements — never as HTML,
 * so whatever text it holds is only ever text. An empty paragraph keeps its
 * line, which is how a blank line between two paragraphs survives.
 */
function RichTextView({ blocks, className = '' }) {
  if (!Array.isArray(blocks) || !blocks.length) return null;
  return (
    <div className={`${styles.view} ${className}`}>
      {blocks.map((b, i) => {
        if (b.type === 'bullet' || b.type === 'numbered') {
          const List = b.type === 'bullet' ? 'ul' : 'ol';
          return (
            <List key={i}>
              {(b.items || []).map((item, j) => <li key={j}><Runs runs={item || []} /></li>)}
            </List>
          );
        }
        const runs = b.children || [];
        return <p key={i}>{runs.some(r => r.text) ? <Runs runs={runs} /> : <br />}</p>;
      })}
    </div>
  );
}

export default RichTextView;
